import React from "react"
import PropTypes from "prop-types"
import * as yup from "yup"
import { useTranslation } from "react-i18next"
import { Formik, Form, Field } from "formik"
import { Spacer, Button } from "@bw/bits"
import { Input, FormField } from "@bw/forms"
import { navigate } from "gatsby"
import YupPassword from "yup-password"
YupPassword(yup)

const Reset = ({ onSubmit, setActiveStep }) => {
  const { t } = useTranslation()
  const initialValues = {
    email: "",
    password: "",
    password_repeat: "",
  }

  if (typeof window === "undefined") {
    return null
  }

  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get("token")

  if (!token) {
    navigate("/")
    return null
  }

  return (
    <Spacer>
      <Formik
        initialValues={initialValues}
        validationSchema={yup.object().shape({
          email: yup.string().required(),
          password: yup
            .string()
            .password()
            .minLowercase(1, "Utilisez au moins une lettre minuscule")
            .minUppercase(1, "Utilisez au moins une lettre majuscule")
            .minNumbers(1, "Utilisez au moins un nombre")
            .minSymbols(1, "Utilisez au moins un symbole (-_+*, etc.)")
            .min(12, "Utilisez au moins 12 caractères")
            .required(),
          password_repeat: yup
            .string()
            .oneOf([yup.ref("password"), null], t("form.passwordsMustMatch")),
        })}
        onSubmit={(values, actions) => {
          actions.setSubmitting(true)

          onSubmit(values).then(() => {
            setActiveStep('login')
          }).finally(() => {
            actions.setSubmitting(false)
          })
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <FormField title={t("authentication:email")} name="email" required>
              <Field type="email" id="email" name="email" component={Input} />
            </FormField>

            <FormField
              title={t("authentication:password")}
              name="password"
              required
            >
              <Field
                type="password"
                id="password"
                name="password"
                component={Input}
              />
            </FormField>

            <FormField
              title={t("authentication:password_repeat")}
              name="password_repeat"
              required
            >
              <Field
                type="password"
                id="password_repeat"
                name="password_repeat"
                component={Input}
              />
            </FormField>

            <Button
              submit
              small
              label={t("authentication:resetSubmit")}
              disabled={isSubmitting}
            />
          </Form>
        )}
      </Formik>
    </Spacer>
  )
}

Reset.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default Reset
